import { render, staticRenderFns } from "./formAdd_news.vue?vue&type=template&id=4270c470&scoped=true"
import script from "./formAdd_news.vue?vue&type=script&lang=js"
export * from "./formAdd_news.vue?vue&type=script&lang=js"
import style0 from "./formAdd_news.vue?vue&type=style&index=0&id=4270c470&prod&lang=css&scoped=true"
import style1 from "./formAdd_news.vue?vue&type=style&index=1&id=4270c470&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4270c470",
  null
  
)

export default component.exports